import { render, staticRenderFns } from "./Auth.vue?vue&type=template&id=2b7575d8"
import script from "./Auth.vue?vue&type=script&lang=ts"
export * from "./Auth.vue?vue&type=script&lang=ts"
import style0 from "./Auth.vue?vue&type=style&index=0&id=2b7575d8&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b7575d8')) {
      api.createRecord('2b7575d8', component.options)
    } else {
      api.reload('2b7575d8', component.options)
    }
    module.hot.accept("./Auth.vue?vue&type=template&id=2b7575d8", function () {
      api.rerender('2b7575d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Auth.vue"
export default component.exports